
import React from "react";
import { PanelBarGLPure, GridSelectionHLPure } from "../../pures";
import { Grid } from '@material-ui/core';
import "./consult-negotiation-guests.css";

const ConsultNegotiationGuestView = (props) => {
    let {
        t,  
        guests
    } = props

    let heightGrid = '320px'

    if(guests.length === 1 || guests.length === 0){
        heightGrid = '110px'
    }else if(guests.length === 2){
        heightGrid = '180px'
    }else if(guests.length === 3){
        heightGrid = '280px'
    }else{
        heightGrid = '320px'
    }

    const headerColumnOne = (props) => {
        return <span className="consultNegotiationGuestView-header-cell-one">{props.title}</span>;
    };

    const headerColumnTwo = (props) => {
        return <span className="consultNegotiationGuestView-header-cell-two">{props.title}</span>;
    };

    const cellColumnOne = (props) => {
        return (
            <td className='consultNegotiationGuestView-cell-one'>
                <span className="gridHLPure-userName">
                    {props.dataItem.fullName}
                </span>
            </td>
        );
    };

    const cellColumnTwo = (props) => {
        return (
            <td className='consultNegotiationGuestView-cell-two'>
                <span className="gridHLPure-fieldSubtitle">
                    {props.dataItem.email}
                </span>
            </td>
        );
    };

    
    return(
        <div className="consultNegotiationGuestView-guests">
            <PanelBarGLPure
                expandedPanel={true}
                titlePanel={t("consultNegotiation.panels.bar.title.guests")}
                className='consultNegotiationGuestView'
            >
                <Grid item className="consultNegotiationGuestView-grid-documents">
                    <GridSelectionHLPure
                        styleGeneral={true}
                        styleGeneralClass={"consultNegotiationGuestView-general-grid"}
                        pageable={false}
                        skip={0}
                        take={guests.length}
                        dataGrid={guests}
                        filter={false}
                        columnTwo={true}
                        titleRow1={t("consultNegotiation.guests.grid.title.1")}
                        titleRow2={t("consultNegotiation.guests.grid.title.2")}
                        headerColumnOne={headerColumnOne}
                        headerColumnTwo={headerColumnTwo}
                        cellColumnOne={cellColumnOne}
                        cellColumnTwo={ cellColumnTwo }
                        styleGrid={{ height: heightGrid }}
                    />
                </Grid>            
            </PanelBarGLPure>
        </div>
    )
}

export { ConsultNegotiationGuestView as default }